import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DataToBeUpdatedComponent } from "./data-to-be-updated/data-to-be-updated.component";
import { ErrorLogMonitoringComponent } from "./error-log-monitoring/error-log-monitoring.component";
import { TestComparisonComponent } from "./test-comparison/test-comparison.component";
import { SharedModule } from "../../shared/shared.module";
import { FlandersCitiesComponent } from "./data-to-be-updated/flanders-cities/flanders-cities.component";
import { BxlCitiesComponent } from "./data-to-be-updated/bxl-cities/bxl-cities.component";
import { WalloniaCitiesComponent } from "./data-to-be-updated/wallonia-cities/wallonia-cities.component";
import { RouterModule } from "@angular/router";
import { DatesSummaryComponent } from "./dates-summary/dates-summary.component";
import { AdvancedOverviewComponent } from "./advanced-overview.component";
import { LayoutModule } from "@angular/cdk/layout";
import { ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../../shared/material.module";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";

@NgModule({
    declarations: [
        AdvancedOverviewComponent,
        DataToBeUpdatedComponent,
        ErrorLogMonitoringComponent,
        DatesSummaryComponent,
        TestComparisonComponent,
        FlandersCitiesComponent,
        BxlCitiesComponent,
        WalloniaCitiesComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        LayoutModule,
        ReactiveFormsModule,
        MaterialModule,
        MatDatepickerModule,
    ],
    exports: [
        DataToBeUpdatedComponent,
    ],
    providers: [
        MatNativeDateModule,
        { provide: MAT_DATE_LOCALE, useValue: "fr-FR" },
    ],
})
export class AdvancedOverviewModule {}
